import PostInputs from "../components/PostInputs";
import { PostEditingDetails } from "../PostEditor/PostEditor/postEditorConstants";

interface PostCardInputsProps {
  postDetail: PostEditingDetails; // Use the specific type
  toggleShowInputs: () => void;
  handleToggleTheme: () => Promise<void>;
}

const PostCardInputs = ({
  postDetail,
  toggleShowInputs,
  handleToggleTheme,
}: PostCardInputsProps) => {
  return (
    <div
      className="absolute inset-0 w-full h-full p-4 overflow-y-auto"
      onClick={(e) => e.stopPropagation()}
    >
      <PostInputs
        postDetail={postDetail}
        showAsPopover={false}
        handleToggleTheme={handleToggleTheme}
      />
    </div>
  );
};

export default PostCardInputs;
